module.exports = __webpack_public_path__ + "assets/629ec7742d42e516170fa2309d4f31bb.mp3";